window.EventBus = new Vue();

//main vue instance
new Vue({
    el: '#app',
    store,
    data: {
        showLightBox: false,
        index: 0,
        imgs: [],
        showError: false,
        errorMsg: ''
    },

    computed: {
        fn() {
            return this.$store.getters.fn;
        },

        currentPage() {
            return this.$store.getters.currentPage;
        },

        members() {
            return this.$store.getters.membersData;
        }
    },
    mounted() {

        this.$store.commit('SAVE_FAMILY', this.$fn);

        this.getFamilyInformation();

        EventBus.$on('SHOW_LIGHTBOX', ({imgs, index}) => {
            this.imgs = imgs;
            this.index = index - 1;
            this.showLightBox = true;
        });

        this.$refs.lightbox.$on('hide', () => {
            this.showLightBox = false;
        })
    },
    methods: {
        getFamilyInformation() {
            if (this.fn != null) {
                this.$store.dispatch('GET_FAMILY_INFORMATION', this.fn)
                    .then(res => {

                        if (this.$pn && this.$kd) {
                            // if a pn and a kd are set as get parameter, directly go to the member

                            let index = this.members.findIndex(member => {
                                return member.c_publicationnumber == this.$pn && member.c_kindcode == this.$kd;
                            });

                            if (index != -1) {
                                this.$refs.sideBar.goToMember(index)
                            }

                        }

                        EventBus.$emit('FETCHED_MEMBERS');
                        EventBus.$emit('HIDE_LOADING');
                        $('[data-toggle="tooltip"]').tooltip();
                    })
                    .catch(err => {
                        console.log(err);
                        if (err.error) {
                            this.showError = true;
                            this.errorMsg = err.msg;
                        }
                    });
            } else {
                //if there is no fn but a pn and kd, get the family number from the db then call the function again
                if (this.$pn && this.$kd) {
                    this.$store.dispatch('GET_FAMILY_NUMBER', [this.$pn,this.$fn])
                        .then(res => {
                            this.getFamilyInformation();
                        })
                        .catch(err => {
                        })

                }
            }
        }
    }
});
